import React from 'react';

const VisionForFuture = () => {
  return (
    <div className="w-full">
      {/* Top section with dark blue background */}
      <div className="bg-indigo-900 text-white py-16 relative overflow-hidden">
        {/* Circle decorations */}
        <div className="absolute left-0 top-0 w-32 h-32 rounded-full border-8 border-indigo-800 opacity-70 -translate-x-1/4 -translate-y-1/4"></div>
        <div className="absolute right-0 bottom-0 w-48 h-48 rounded-full border-8 border-indigo-800 opacity-70 translate-x-1/4 translate-y-1/4"></div>
        
        <div className="container mx-auto px-8 max-w-5xl">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">24-7's Vision for the Future!</h2>
          
          <p className="mb-4">
            At 24-7 Consultancy, we are more than just a team of experts. We are a team of visionaries passionate about building a better tomorrow. Technology and innovation can solve important problems in the world. We use our knowledge and skills to assist our clients in reaching their goals and making a positive difference.
          </p>
          
          <p className="font-medium mb-3">Our goals for the future include:</p>
          
          <ul className="list-disc pl-8 space-y-2">
            <li>Expanding our expertise and reaching new clients so that we can help even more people benefit from our services.</li>
            <li>Investing in new technologies and capabilities so that we can deliver even better results for our clients.</li>
            <li>Building a broader team of talented, dedicated professionals passionate about making a difference.</li>
            <li>We believe that together, we can create a brighter future for all.</li>
          </ul>
        </div>
      </div>
      
      {/* Bottom section with light background and awards */}
      <div className="bg-gray-100 py-16">
        <div className="container mx-auto px-8 max-w-5xl">
          <div className="flex flex-col md:flex-row">
            {/* Left section - Title */}
            <div className="md:w-1/3 mb-8 md:mb-0">
              <h2 className="text-3xl font-bold text-gray-900">
                Achievements & <span className="text-blue-500">Awards</span>
              </h2>
            </div>
            
            {/* Right section - Awards grid */}
            <div className="md:w-2/3">
              <div className="grid grid-cols-3 gap-4">
                {/* Award logos - Row 1 */}
                <div className="bg-white p-4 flex items-center justify-center border border-gray-200">
                  <div className="rounded-full p-2 border border-gray-500 flex flex-col items-center text-center">
                    <div className="text-xs font-bold">GROWING</div>
                    <div className="text-xs">2022</div>
                  </div>
                </div>
                
                <div className="bg-white p-4 flex items-center justify-center border border-gray-200">
                  <div className="rounded-full p-2 border border-gray-500 flex items-center justify-center">
                    <div className="text-xs font-bold text-center">CERTIFIED</div>
                  </div>
                </div>
                
                <div className="bg-white p-4 flex items-center justify-center border border-gray-200">
                  <div className="p-2 border border-gray-300 rounded-full text-center">
                    <div className="text-xs font-bold">TOP</div>
                    <div className="text-xs">HEALTHCARE</div>
                    <div className="text-xs">EMPLOYERS</div>
                  </div>
                </div>
                
                {/* Award logos - Row 2 */}
                <div className="bg-white p-4 flex items-center justify-center border border-gray-200">
                  <div className="rounded-full p-2 border border-gray-500 flex items-center justify-center">
                    <div className="text-xs font-bold text-center">OFFICES</div>
                  </div>
                </div>
                
                <div className="bg-white p-4 flex items-center justify-center border border-gray-200">
                  <div className="rounded-full p-2 border border-gray-500 flex items-center justify-center">
                    <div className="text-xs font-bold text-center">BUSINESS AWARD</div>
                  </div>
                </div>
                
                <div className="bg-white p-4 flex items-center justify-center border border-gray-200">
                  <div className="rounded-full p-2 border border-gray-500 flex items-center justify-center">
                    <div className="text-xs font-bold text-center">100%</div>
                    <div className="text-xs">SATISFACTION</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisionForFuture;